import { isLogoutForm, isZendeskLoaded } from './zendesk-identity';

// This module stays dependency-free on purpose: the public entry installs the interceptor
// eagerly on every page, and pulling in zendesk-chat.ts would drag axios, Sentry and
// TokenService into the eager common-inline bundle.

let isInstalled = false;
let isLogoutInProgress = false;

// The public entry needs a dynamic import to reach the chat service, so a handler may be
// asynchronous. The member SPA passes a synchronous one.
export type LogoutHandler = () => Promise<void> | void;

const handleSubmit = (onLogout: LogoutHandler) => (event: Event): void => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !isLogoutForm(form) || isLogoutInProgress) {
    return;
  }

  // Logout is a full-page POST and the widget is usually not loaded at that point, so there
  // is nothing to log out of yet. The marker deliberately survives: it is the only record
  // that Zendesk still holds this user's session, and the next open acts on it.
  if (isZendeskLoaded()) {
    event.preventDefault();
    isLogoutInProgress = true;

    // The user's logout must never wait on Zendesk, so the form is submitted either way.
    Promise.resolve(onLogout())
      .catch(() => undefined)
      .finally(() => {
        form.submit();
      });
  }
};

export const installLogoutInterceptor = (onLogout: LogoutHandler): void => {
  if (isInstalled) {
    return;
  }

  isInstalled = true;
  document.addEventListener('submit', handleSubmit(onLogout), true);
};
